import React, {
  Fragment,
  useState,
  useContext,
  useCallback,
  useEffect,
} from 'react';
import { useLocation } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import {
  THEME,
  lightTheme,
  darkTheme,
  iceTheme,
  blueberryTheme,
} from '@mummssoftware/common-ui';
import FlareIcon from '@material-ui/icons/Flare';
import { SET_THEME_OVERLAY } from '../Context/constants';
import { Context } from '../../context';
import { DashboardContext } from '../Context/contexts/DashboardContext';
import { StyledActionIcon } from '../../components';

const ITEM_HEIGHT = 38;

const useStyles = makeStyles((theme) => ({
  menuPaper: { maxHeight: ITEM_HEIGHT * 4, width: 110 },
}));

export const ThemeMenu = () => {
  const classes = useStyles();
  const { dispatch } = useContext(DashboardContext);
  const { onDashboardThemeChange } = useContext(Context);
  const themeNames = [darkTheme, blueberryTheme, iceTheme, lightTheme];

  // console.log('isValidTheme? ', isValidTheme);

  const [anchorEl, setAnchorEl] = useState(null);

  const onOpen = (e: any) => {
    setAnchorEl(e.currentTarget);
  };

  const onClose = () => {
    setAnchorEl(null);
  };

  const location = useLocation();
  const query = new URLSearchParams(location.search.toLowerCase());
  const pimTheme = query.get('theme');
  const isValidTheme = pimTheme != null && themeNames.includes(pimTheme);

  const setTheme = useCallback(
    (theme: string) => () => {
      const storedTheme = localStorage.getItem(THEME);

      if (storedTheme !== theme) {
        window.top &&
          window.top.postMessage(theme, `${process.env.REACT_APP_PIM_BASEURL}`);

        dispatch({
          type: SET_THEME_OVERLAY,
          payload: true,
        });
        setTimeout(function () {
          localStorage.setItem(THEME, theme);
          onDashboardThemeChange(theme);
          console.log(
            'THEME: ',
            THEME,
            'Pim Theme: ',
            pimTheme,
            'theme: ',
            theme,
          );
        }, 500);
      }

      setAnchorEl(null);
    },
    [dispatch, onDashboardThemeChange, pimTheme],
  );

  useEffect(() => {
    if (pimTheme) {
      setTheme(pimTheme)();
    }
  }, [pimTheme, setTheme]);

  return (
    <Fragment>
      {!isValidTheme ? (
        <>
          <StyledActionIcon
            Icon={FlareIcon}
            onClick={onOpen}
            id="theme-ribbon"
          />
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={onClose}
            PaperProps={{
              classes: { elevation8: classes.menuPaper },
            }}
          >
            {(themeNames as any).map((item: string) => (
              <MenuItem key={item} onClick={setTheme(item)}>
                {item}
              </MenuItem>
            ))}
          </Menu>
        </>
      ) : (
        setTheme(pimTheme!)
      )}
    </Fragment>
  );
};
export default ThemeMenu;
